var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.pageList.length,
          expression: "pageList.length"
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "pagination-wrapper __pointer" },
        [
          _c("span", {
            staticClass: "box prev",
            class: {
              unuse: _vm.currentPage <= 1
            },
            on: {
              click: function($event) {
                return _vm._toPage(_vm.currentPage - 1)
              }
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.pageList, function(pageNumber, i) {
            return _c(
              "span",
              {
                key: i,
                staticClass: "box",
                class: {
                  active: pageNumber === _vm.currentPage,
                  ellipsis: pageNumber === "..."
                },
                on: {
                  click: function($event) {
                    return _vm._toPage(pageNumber)
                  }
                }
              },
              [_vm._v(_vm._s(pageNumber))]
            )
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "box next",
            class: {
              unuse: _vm.currentPage >= _vm.totalPage
            },
            on: {
              click: function($event) {
                return _vm._toPage(_vm.currentPage + 1)
              }
            }
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }